export default {
  home: {
    title: 'HTML5游戏合集',
    subtitle: '在浏览器中即时游玩，无需下载，即玩即走！',
    browseGames: '浏览游戏',
    popularGames: '热门游戏',
    newGames: '新游戏',
    recommendedGames: '推荐游戏',
    recentlyPlayed: '最近玩过',
    popular: '热门',
    genres: {
      casual: '休闲',
      puzzle: '益智',
      racing: '赛车',
      racing_driving: '赛车与驾驶',
      shooter: '射击',
      simulation: '模拟',
      strategy: '策略',
      sports: '体育',
      agility: '敏捷',
      battle: '对战',
      care: '照顾',
      cooking: '烹饪',
      football: '足球',
      '.IO': '即时对战',
      merge: '合并',
      all: '全部',
      other: '其他',
      dressup: '换装',
      adventure: '冒险',
      mahjong_connect: '麻将与连接',
      jigsaw: '拼图',
      basketball: '篮球',
      quiz: '问答',
      bubble_shooter: '泡泡射击',
      match3: '三消',
      boardgames: '棋盘游戏',
      educational: '教育',
      cards: '卡牌'
    }
  },
  games: {
    playNow: '立即玩',
    relatedGames: '相关游戏',
    instructions: '游戏说明',
    controlsTitle: '游戏控制',
    addToFavorites: '添加到收藏',
    removeFromFavorites: '从收藏中移除',
    share: '分享游戏',
    reportIssue: '报告问题',
    fullscreen: '全屏模式',
    exitFullscreen: '退出全屏'
  },
  categories: {
    title: '游戏分类',
    subtitle: '探索我们丰富的游戏分类',
    allCategories: '所有分类',
    gamesInCategory: '{count} 个游戏',
    categoryDescription: '在这里你可以找到所有 {category} 类的游戏。从不同的风格中挑选并立即开始游戏！',
    pageTitle: '游戏分类',
    pageDescription: '探索我们多样化的游戏分类，找到您最喜爱的游戏类型',
    allGames: '所有游戏',
    gamesFound: '{count} 个游戏',
    other: '其他',
    taggedGames: '{tag}游戏',
    noGamesInCategory: '该分类下暂无游戏',
    loadMore: '加载更多',
    otherGames: '其他游戏',
    seoTitle: 'GoGameVault - 游戏分类 | 免费在线HTML5游戏',
    seoDescription: '探索GoGameVault多样化的游戏分类，包括动作、益智、街机、体育、赛车等，找到您最喜爱的游戏类型。',
    seoKeywords: '游戏分类,在线游戏,免费游戏,HTML5游戏,浏览器游戏',
    descriptions: {
      'Casual': '简单易玩的休闲游戏，适合所有年龄段的玩家，无压力地享受游戏乐趣。',
      'Puzzle': '通过解决谜题和智力挑战带来满足感的脑力训练益智游戏。',
      'Racing & Driving': '体验速度与激情，挑战各种赛道的刺激赛车和驾驶游戏。',
      'Shooter': '测试你的瞄准精度和反应时间的射击游戏，击败所有敌人。',
      'Simulation': '从城市管理到飞机驾驶，模拟现实世界中的各种体验，充分体验不同角色。',
      'Strategy': '需要谨慎规划和战术思考的策略游戏，制定最佳战略以取得胜利。',
      'Sports': '模拟各种体育项目的运动游戏，展示你的运动天赋。',
      'Agility': '测试反应速度和协调能力的敏捷游戏，快速应对各种挑战。',
      'Battle': '与对手进行激烈竞争的对战游戏，凭借技巧和策略取得胜利。',
      'Care': '体验照顾宠物、病人或其他角色的乐趣的照顾游戏。',
      'Cooking': '展示烹饪才能，制作美味料理并管理餐厅的烹饪游戏。',
      'Football': '体验世界上最受欢迎的运动，展示你的球技和战术的足球游戏。',
      '.IO': '即时对战游戏，多人在线竞技类游戏，与全球玩家一起竞争和成长。',
      'Merge': '合并类游戏，通过合并相同物品来创造新物品，简单有趣且令人上瘾。',
      'other': '不属于常规类别的独特游戏体验。',
      'generic': '探索各种{tag}类型的游戏，找到你的最爱。'
    }
  },
  search: {
    title: '搜索结果',
    placeholder: '搜索游戏...',
    resultsFor: '"{query}" 的搜索结果',
    noResults: '未找到游戏',
    noResultsMessage: '未找到与 "{query}" 相关的游戏',
    tryAgain: '请尝试使用不同的关键词或浏览我们的分类。',
    returnToHomepage: '返回首页',
    foundResults: '找到 {count} 个游戏',
    seoTitle: '搜索 "{query}" - GoGameVault | 免费在线HTML5游戏',
    seoDescription: 'GoGameVault上搜索"{query}"相关的免费在线HTML5游戏。找到各种有趣的游戏，无需下载，直接在浏览器中畅玩。'
  },
  gameDetail: {
    title: '游戏详情',
    gameTitle: '游戏标题',
    genres: '游戏类型',
    tags: '标签',
    gameDescription: '游戏描述',
    controlsAndInstructions: '操作和说明',
    similarGames: '相似游戏',
    new: '新游戏',
    playAmazingGame: '立即体验这个精彩游戏',
    noSimilarGames: '没有相似游戏',
    gameNotFound: '找不到游戏',
    gameNotExistOrRemoved: '此游戏不存在或已被移除',
    backToHome: '返回首页',
    seoTitle: '{title} - 免费在线玩 | GoGameVault',
    seoTitleNotFound: '找不到游戏 | GoGameVault',
    seoKeywords: '{title}, 在线游戏, 免费游戏, {tags}, HTML5游戏',
    gameUnavailable: '游戏暂时不可用',
    tryAgainLater: '请稍后再试',
    share: '分享',
    openInNewTab: '在新标签页中打开'
  },
  about: {
    title: '关于我们',
    aboutUs: '关于我们',
    ourMission: '我们的使命',
    contactUs: '联系我们',
    privacyPolicy: '隐私政策',
    termsOfService: '服务条款',
    feedbackTitle: '意见反馈',
    feedbackText: '我们一直在努力提高网站质量。如果您有任何建议或发现问题，请告诉我们！',
    missionTitle: '我们的使命',
    missionText1: 'GoGameVault致力于为用户提供最好的免费在线游戏体验。我们精心挑选有趣、高质量的HTML5游戏，让您无需下载即可享受游戏乐趣。',
    missionText2: '我们的目标是创建一个用户友好的游戏平台，让玩家可以简单地找到并玩到他们喜欢的游戏。',
    feature1Title: '精选游戏',
    feature1Text: '我们精心挑选每一款游戏，确保它们具有高质量的画面和流畅的游戏体验。',
    feature2Title: '随时随地玩',
    feature2Text: '所有游戏都可以在您的浏览器中直接运行，无需下载或安装任何额外软件。',
    feature3Title: '完全免费',
    feature3Text: '我们的所有游戏都是完全免费的，没有任何隐藏费用或内购。',
    contactTitle: '联系我们',
    contactText: '如果您有任何问题、建议或反馈，请随时与我们联系。我们非常重视用户的意见，并致力于不断改进我们的服务。',
    seoTitle: 'GoGameVault - 关于我们 | 免费在线HTML5游戏',
    seoDescription: 'GoGameVault是一个免费的在线HTML5游戏平台，提供精选游戏，无需下载，让您随时随地畅玩。了解我们的使命和特色。',
    seoKeywords: '在线游戏,免费游戏,HTML5游戏,浏览器游戏,无需下载'
  },
  notFound: {
    title: '页面未找到',
    message: '抱歉，您访问的页面不存在或已被移除。让我们带您回到正轨！',
    returnHome: '返回首页',
    goBack: '返回上一页',
    popularGames: '热门游戏推荐',
    popularGamesDesc: '探索这些精选游戏，开启您的游戏之旅',
    seoTitle: '页面未找到 - GoGameVault',
    seoDescription: '抱歉，您访问的页面在GoGameVault上不存在。浏览我们的热门游戏，开启新的游戏体验。'
  },
  categoryGames: {
    games: '游戏',
    gamesAvailable: '{count} 个游戏可用',
    noGamesFound: '未找到游戏',
    noGamesInCategory: '该分类下暂无游戏',
    exploreCategories: '探索其他分类',
    backToCategories: '返回分类',
    invalidCategory: '无效分类',
    categoryNotExist: '您查找的分类不存在。',
    browseCategories: '浏览所有分类',
    category: '分类',
    seoTitle: '{tag}游戏 - 在线玩 - GoGameVault',
    seoDescriptionWithGames: '浏览并免费游玩{count}款精选{tag}游戏。所有游戏都可以直接在浏览器中玩，无需下载。',
    seoDescriptionDefault: '浏览并免费游玩我们的{tag}游戏。所有游戏都可以直接在浏览器中玩，无需下载。',
    seoKeywords: '{tag}游戏,免费在线游戏,浏览器游戏'
  }
}; 